import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { VIEW } from "const"
import { LifecyclePhase } from "server/models"
import { lifecyclesRoute, projectsRoute } from "client/parts/routes"
import {
    StoreType,
    addModal,
} from "client/store"
import {
    FormGroup,
    Label,
    CheckboxWrapper,
    CheckButton,
    Link,
    EmptySpan,
} from "client/components"


interface LifecyclePhasesProps {
    phases: number[]
    setPhases: (phases: number[]) => void
}

const LifecyclePhases = ({
    phases,
    setPhases,
}: LifecyclePhasesProps) => {
    const lifecycles = useSelector((state: StoreType) => state.ccRequirement.lifecyclesEdit)
    const lifecyclePhaseList = useSelector((state: StoreType) => state.ccRequirement.lifecyclePhaseListEdit)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    return (
        <FormGroup>
            <Label>{lang.lifecyclePhases}</Label>
            {
                lifecycles.length === 0
                && <EmptySpan style={{ marginBottom: "8px" }}>{lang.noLifecycles}</EmptySpan>
            }
            {
                lifecycles.map((lifecycle) => {
                    const href = `${projectsRoute}/${VIEW}/${project.id}${lifecyclesRoute}/${VIEW}/${lifecycle.id}`
                    const phaseList = lifecyclePhaseList[lifecycle.id]
                    if (!phaseList) return null

                    const colNumber = 2

                    const phaseColumnLength = Math.ceil(phaseList.length / colNumber)
                    const phaseColumns: { [k: number]: LifecyclePhase[] } = {}
                    for (let i = 0; i < colNumber; i++) {
                        const column = []
                        const start = i * phaseColumnLength
                        const end = start + phaseColumnLength
                        for (let k = start; k < end; k++) {
                            column.push(phaseList[k] || null)
                        }
                        phaseColumns[i] = column
                    }

                    return (
                        <Row key={lifecycle.id}>
                            <Col xs={12}>
                                <Link
                                    href={href}
                                    onClick={() => dispatch(addModal({ url: href }))}
                                >
                                    {lifecycle.name}
                                </Link>
                                <CheckboxWrapper>
                                    {
                                        Object.keys(phaseColumns).map((index) => (
                                            <Col key={index} xs={12 / colNumber}>
                                                {
                                                    phaseColumns[Number(index)].map((phase) => {
                                                        if (!phase) return null

                                                        const checked = phases.includes(phase.id)
                                                        return (
                                                            <CheckButton
                                                                key={phase.id}
                                                                title={phase.name}
                                                                checked={checked}
                                                                onChange={() => {
                                                                    let newPhases: number[] = phases.slice()
                                                                    if (checked) {
                                                                        newPhases = newPhases.filter((id) => id !== phase.id)
                                                                    } else {
                                                                        newPhases.push(phase.id)
                                                                    }
                                                                    setPhases(newPhases)
                                                                }}
                                                            />
                                                        )
                                                    })
                                                }
                                            </Col>
                                        ))
                                    }
                                </CheckboxWrapper>
                            </Col>
                        </Row>
                    )
                })
            }
        </FormGroup>
    )
}
export default LifecyclePhases
